export default "__VITE_ASSET__U5i2V3Q5__"